import React from 'react';
import { Link } from 'react-router-dom';

const LoanSection = () => {
  const loanList = [
    {
      title: "HOME LOAN",
      description: "Turn your dream home into reality with low-interest rates, flexible tenures, and fast approvals.",
      image: "/images/home-loan.jpg",
      features: ["+ Low Interest Rates", "+ Quick Sanction", "+ Flexible Tenure"],
      path: "/home-loan",
      bgColor: "rgba(58, 36, 85, 0.9)" // Deep Purple
    },
    {
      title: "CAR LOAN",
      description: "Drive home your dream vehicle with 100% financing options and minimal documentation.",
      image: "/images/car-loan.jpg",
      features: ["+ 100% Financing", "+ Easy Processing", "+ Minimal Paperwork"],
      path: "/car-loan",
      bgColor: "rgba(22, 96, 128, 0.9)" // Teal / Blue
    },
    {
      title: "EDUCATION LOAN",
      description: "Invest in your future globally with comprehensive financial support for tuition and living expenses.",
      image: "/images/education-loan.jpg",
      features: ["+ Global Universities", "+ Moratorium Period", "+ Tax Benefits"],
      path: "/education-loan",
      bgColor: "rgba(20, 84, 56, 0.9)" // Emerald Green
    }
  ];

  return (
    <section 
      className="resources-section py-5 position-relative overflow-hidden" 
      style={{
        backgroundImage: `url('/images/lotos-wealth-bg2.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Dark overlay for base contrast */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-black" style={{ opacity: '0.4', zIndex: 0 }}></div>

      <div className="container py-5 position-relative" style={{ zIndex: 1 }}>
        
        {/* Top Header Row */}
        <div className="row text-center mb-5 pb-lg-3">
          <div className="col-lg-8 mx-auto">
            <span className="text-warning fw-bold small text-uppercase tracking-wider">Welcome to Lotoswealth</span>
            <h2 className="display-6 fw-bold text-white mt-2 mb-3" style={{ letterSpacing: '-1px', lineHeight: '1.2' }}>
              We specialize in Investment, Tax Planning, Loans, and Wealth Management Services.
            </h2>
            <p className="text-light small opacity-75">
              Empowering your financial journey with customized strategies to grow your wealth, protect your assets, and secure your future.
            </p>
          </div>
        </div>

        {/* 3-Column Content Section with Increased Image Sizes */}
        <div className="row g-4 align-items-stretch">
          {loanList.map((item, index) => (
            <div key={index} className="col-lg-4">
              <div 
                className="p-4 p-lg-5 d-flex flex-column justify-content-between h-100 shadow-lg text-white"
                style={{
                  backgroundColor: item.bgColor,
                  borderRadius: '16px',
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(255, 255, 255, 0.15)'
                }}
              >
                <div>
                  {/* Increased Image Container Size */}
                  <div className="mb-4 overflow-hidden rounded-4 position-relative shadow w-100" style={{ height: '180px' }}>
                    <img 
                      src={item.image} 
                      alt={item.title} 
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>

                  {/* Title */}
                  <h3 className="fw-bold text-white fs-4 mb-3" style={{ letterSpacing: '0.5px' }}>
                    {item.title}
                  </h3>

                  {/* Description */}
                  <p className="text-light small mb-4 opacity-75" style={{ lineHeight: '1.7' }}>
                    {item.description}
                  </p>
                </div>

                <div>
                  {/* Features List */}
                  <ul className="list-unstyled small mb-4">
                    {item.features.map((feat, idx) => (
                      <li key={idx} className="mb-2 fw-medium text-light">{feat}</li>
                    ))}
                  </ul>

                  {/* Read More / More Info Button */}
                  <div className="pt-2 text-center">
                    <Link 
                      to={item.path} 
                      className="btn btn-light btn-sm text-dark fw-bold px-4 py-2 rounded-pill shadow-sm text-decoration-none"
                      style={{ transition: 'all 0.2s ease-in-out' }}
                    >
                      More Info
                    </Link>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LoanSection;